export function isValidCallbackURL(url: string): boolean {
	if (!url.startsWith("/")) {
		return false;
	}
	if (url.startsWith("//")) {
		return false;
	}
	if (url.includes("://")) {
		return false;
	}
	return true;
}
